import { render } from "./RegisterValidateView.vue?vue&type=template&id=6d06cee3"
import script from "./RegisterValidateView.vue?vue&type=script&lang=js"
export * from "./RegisterValidateView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__